module.exports = __webpack_public_path__ + "static/dso-c72b53dac3cdf8174b20e6cc06ef08ec.jpg";